export default __webpack_public_path__ + "static/media/franchise-template-1.1bacf527.svg";